import * as Types from './types'

export const FETCH_PROMOTIONS = 'FETCH_PROMOTIONS'
export const ADD_PROMOTION = 'ADD_PROMOTION'
export const UPDATE_PROMOTION = 'UPDATE_PROMOTION'
export const EDIT_PROMOTION = 'EDIT_PROMOTION'
export const UPLOAD_IMAGE_PROMOTION = 'UPLOAD_IMAGE_PROMOTION'

export const SERVER_RESOURCE = '/promotions'

export const emptyModalState: Types.ModalData = {
  category_type_id: 0,
  end_date: null,
  id: null,
  image_url: '',
  promotion_id: null,
  promotion_type_id: 0,
  rank: 0,
  start_date: null,
  target_url: '',
  title: '',
}



// WEBPACK FOOTER //
// ./src/pages/promotions/constants.ts